import React, { useState } from "react";
import {
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  TextField,
} from "@mui/material";
import LongTextComponent from "../Leads Page/LongTextComponent";

function OpenRemarkList({ openRemarkData }) {
  const [page, setPage] = useState(0); // Current page
  const [rowsPerPage, setRowsPerPage] = useState(10); // Rows per page
  const [search, setSearch] = useState(""); // Search term

  // Handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Handle rows per page change
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to the first page
  };

  // Handle search input change
  const handleSearchChange = (event) => {
    setSearch(event.target.value);
  };

  // Filter data based on search term
  const filteredData = openRemarkData.filter((data) => {
    const searchLower = search.toLowerCase();
    return (
      data.Lot_Number?.toLowerCase().includes(searchLower) ||
      data.Farmer_Name?.toLowerCase().includes(searchLower) ||
      data.Branch_Name?.toLowerCase().includes(searchLower) ||
      data.Zone_Name?.toLowerCase().includes(searchLower) ||
      data.AGE?.toString().toLowerCase().includes(searchLower) ||
      data.BWT?.toString().toLowerCase().includes(searchLower) ||
      data.M_QTY?.toString().toLowerCase().includes(searchLower) ||
      data.REASON?.toLowerCase().includes(searchLower) ||
      data.agent_name?.toLowerCase().includes(searchLower) ||
      data.closure_status?.toLowerCase().includes(searchLower) ||
      data.REMARKS?.toLowerCase().includes(searchLower)
    );
  });

  // Slice filtered data based on pagination
  const paginatedData = filteredData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <Paper
      sx={{
        boxShadow: 2,
        borderRadius: "8px",
        margin: "16px 0",
        overflow: "hidden",
      }}
    >
      <TextField
        label="Search"
        variant="outlined"
        size="small"
        sx={{ marginBottom: 2, margin: 1, float: 'right' }}
        value={search}
        onChange={handleSearchChange}
      />
      <TableContainer>
        <Table
          sx={{ minWidth: 650, height: "100%", tableLayout: "fixed" }}
          aria-label="simple table"
        >
          <TableHead>
            <TableRow sx={{ backgroundColor: "#EEF0F4" }}>
              <TableCell align="center" sx={{ width: 50 }}>
                Sno
              </TableCell>
              <TableCell align="center" sx={{ width: 150 }}>
                Lot Number
              </TableCell>
              <TableCell align="center" sx={{ width: 150 }}>
                Farmer Name
              </TableCell>
              <TableCell align="center" sx={{ width: 150 }}>
                Branch Name
              </TableCell>
              <TableCell align="center" sx={{ width: 150 }}>
                Zone Name
              </TableCell>
              <TableCell align="center" sx={{ width: 150 }}>
                Age
              </TableCell>
              <TableCell align="center" sx={{ width: 150 }}>
                Body Weight
              </TableCell>
              <TableCell align="center" sx={{ width: 150 }}>
                Mortality Quantity
              </TableCell>
              <TableCell align="center" sx={{ width: 150 }}>
                Reason
              </TableCell>
              <TableCell align="center" sx={{ width: 150 }}>
                Agent Name
              </TableCell>
              <TableCell align="center" sx={{ width: 150 }}>
                Status
              </TableCell>
              <TableCell align="center" sx={{ width: 150 }}>
                Remarks
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Array.isArray(paginatedData) && paginatedData.length === 0 ? (
              <TableRow>
                <TableCell colSpan={12}>No Data Available Yet.</TableCell>
              </TableRow>
            ) : (
              paginatedData?.map((data, index) => (
                <TableRow key={data.id || index}>
                  <TableCell align="center" sx={{ width: 50, padding: 0 }}>
                    {page * rowsPerPage + index + 1}
                  </TableCell>
                  <TableCell align="center" sx={{ width: 50, padding: 0 }}>
                    {data?.Lot_Number || "-"}
                  </TableCell>
                  <TableCell align="center" sx={{ width: 50, padding: 0 }}>
                    {data?.Farmer_Name || "-"}
                  </TableCell>
                  <TableCell align="center" sx={{ width: 50, padding: 0 }}>
                    {data?.Branch_Name || "-"}
                  </TableCell>
                  <TableCell align="center" sx={{ width: 50, padding: 0 }}>
                    {data?.Zone_Name || "-"}
                  </TableCell>
                  <TableCell align="center" sx={{ width: 50, padding: 0 }}>
                    {data?.AGE || "-"}
                  </TableCell>
                  <TableCell align="center" sx={{ width: 50, padding: 0 }}>
                    {data?.BWT || "-"}
                  </TableCell>
                  <TableCell align="center" sx={{ width: 50, padding: 0 }}>
                    {data?.M_QTY || "-"}
                  </TableCell>
                  <TableCell align="center" sx={{ width: 50, padding: 0 }}>
                    {data?.REASON || "-"}
                  </TableCell>
                  <TableCell align="center" sx={{ width: 50, padding: 0 }}>
                    {data?.agent_name || "-"}
                  </TableCell>
                  <TableCell align="center" sx={{ width: 50, padding: 0 }}>
                    <Chip
                      label={data?.closure_status}
                      color={"error"}
                      size="small"
                      sx={{ textTransform: "capitalize", margin: '5px' }}
                    />
                  </TableCell>
                  <TableCell align="center" sx={{ width: 50, padding: 0 }}>
                    <LongTextComponent
                      text={(data?.REMARKS === null || data?.REMARKS === undefined) ? "-" : data.REMARKS}
                      maxLength={20}
                    />
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 15]}
        component="div"
        count={Array.isArray(filteredData) ? filteredData.length : 0} // Display filtered count
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
}

export default OpenRemarkList;
